import { render, staticRenderFns } from "./SwipedEventBanner.vue?vue&type=template&id=7503160a&scoped=true&"
import script from "./SwipedEventBanner.vue?vue&type=script&lang=js&"
export * from "./SwipedEventBanner.vue?vue&type=script&lang=js&"
import style0 from "./SwipedEventBanner.vue?vue&type=style&index=0&id=7503160a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7503160a",
  null
  
)

export default component.exports